const showMoreButtons = document.querySelectorAll<HTMLButtonElement>('.js-show-more');

for (const showMoreButton of showMoreButtons) {
  const showMoreContainerId = showMoreButton.getAttribute('aria-controls');
  const showMoreContainer = document.querySelector<HTMLElement>(`#${showMoreContainerId}`);

  if (showMoreContainer) {
    showMoreButton.addEventListener('click', () => {
      const isExpanded = showMoreButton.getAttribute('aria-expanded') === 'true';
      showMoreButton.setAttribute('aria-expanded', String(!isExpanded));
      showMoreContainer.classList.toggle('active', !isExpanded);
    });
  }
}
